var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-secondary text-small font-italic text-left"},[_vm._v("\n  "+_vm._s(_vm.$t("ui-measured-last-text"))+" "+_vm._s(_vm.lastUpdatedAt)+".\n  "+_vm._s(_vm.$t("ui-measured-update-text"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }